import React from 'react';
import type { PublicAssetShare } from 'fym-shared/src/music24/assetShares';
import { TypedMemo } from '../../common/types';
import { isStoryShare } from './assetShareFacts';
import { AssetShareStory } from './AssetShareStory';
import { AssetShareTheater } from './AssetShareTheater';
import type { OpenInRelease } from './AssetShareActions';

/**
 * The public view of a shared asset (design asset-share c Theater, owner approved 2026-10-19). A
 * tall video plays full screen like a Story (c6); every other file plays in the theater layout
 * (c1-c5). The page covers the app shell: it has its own Music24 mark and growth line, so the top
 * bar and the trial banner of the shell stay behind it. A visitor sees the file, the song, Listen
 * (the SmartLink of the song) and Copy link or Share. The page has no Download action (owner
 * decision 2026-10-19). A member whose workspace switch failed also gets "Open in release".
 */
const AssetSharePublicViewComponent: React.FC<{ share: PublicAssetShare; openInRelease?: OpenInRelease | null }> = ({
  share,
  openInRelease = null,
}) => {
  if (isStoryShare(share)) {
    return <AssetShareStory share={share} openInRelease={openInRelease} />;
  }
  return <AssetShareTheater share={share} openInRelease={openInRelease} />;
};

export const AssetSharePublicView = TypedMemo(AssetSharePublicViewComponent);
